import { Checkbox } from "client/Components";
import { WorkingDaysModel } from "client/Api/UserProfile/service";
import { IValueInputAttachable } from "client/Forms/attachable";
import {
	getFirstWeekDay,
	DayOfWeek,
	getWeekDays,
	formatDayOfWeek
} from "client/DateAndTime/culture";
import { ReactElement } from "react";

export type WorkingDaysInputProps = {
	attachable: IValueInputAttachable<WorkingDaysModel>;
};

const firstWeekDay: DayOfWeek = getFirstWeekDay();
const weekDays: readonly DayOfWeek[] = getWeekDays(firstWeekDay);

export const WorkingDaysInput = (props: WorkingDaysInputProps): ReactElement => {
	const {
		attachable
	} = props;

	const weekDayToAttachableMap: {[key in DayOfWeek]: IValueInputAttachable<boolean>} = {
		[DayOfWeek.Monday]: attachable.for("monday"),
		[DayOfWeek.Tuesday]: attachable.for("tuesday"),
		[DayOfWeek.Wednesday]: attachable.for("wednesday"),
		[DayOfWeek.Thursday]: attachable.for("thursday"),
		[DayOfWeek.Friday]: attachable.for("friday"),
		[DayOfWeek.Saturday]: attachable.for("saturday"),
		[DayOfWeek.Sunday]: attachable.for("sunday")
	};

	return (
		<>
			{weekDays.map(d => (
				<Checkbox
					{...weekDayToAttachableMap[d].attachToCheckbox()}
					key={d}
					text={formatDayOfWeek(d, "full")}
				/>
			))}
		</>
	);
};
WorkingDaysInput.displayName = "WorkingDaysInput";